import { defineVersionedStorage } from '@heidi/runtime/storage';
import { getUserStorageScope } from '@heidi/utils/jotai-storage';

type BookedByUser = Record<string, true>;

/**
 * Keyed by user rather than a bare boolean: clinicians share workstations, so
 * one person's booking must not disable the CTA for the next person signed in
 * on the same browser.
 */
const bookingStorage = defineVersionedStorage<BookedByUser>({
  key: 'heidi.heidi2.demoBooked.v1',
  version: 1,
  fallback: {},
  validate: (value): value is BookedByUser =>
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    Object.values(value).every((booked) => booked === true),
});

/** True once the signed-in user has booked a demo from this browser. */
export const hasBookedHeidi2Demo = (): boolean => {
  const userScope = getUserStorageScope();
  return userScope !== null && bookingStorage.read()[userScope] === true;
};

/** Records a taken booking. A no-op when no user is resolved to key it against. */
export const markHeidi2DemoBooked = (): void => {
  const userScope = getUserStorageScope();
  if (userScope === null) return;

  bookingStorage.write({ ...bookingStorage.read(), [userScope]: true });
};
